var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

var API_TAKE = 10,
  API_TAKE_ALL = null, // Backend prefers that we send null in order to get all courses.
  API_SKIP = 0;

function MyPlannedCourses(params) {
  this.API = params.api;
  this.links = params.links;
  this.texts = params.texts;
  this.plannedCoursesIntroText = ko.observable(params.plannedCoursesIntroText);
  this.plannedCourses = ko.observableArray([]);
  this.isModalActive = ko.observable(false);
  // Which step the avbestilling modal shows: 'confirm' | 'pending' | 'done' | 'error'.
  this.cancellationState = ko.observable('confirm');
  // Rewind to the first step every time the modal opens, whoever opened it.
  this.isModalActive.subscribe(function(isOpen) {
    if (isOpen) {
      this.cancellationState('confirm');
    }
  }, this);
  this.isLoading = ko.observable(false);
  this.showFetchAllCourses = ko.observable(false);
  this.activeModal = ko.observable(false);
  this.modalTitle = ko.observable('');
  this.modalText = ko.observable('');
  this.activeIndex = ko.observable();
  this.brightCoveNetCourseUrl =
    this.API.brightCoveNetCourseUrl + '?courseSequenceId=';
  this.selectedSequenceId = ko.observable();
  this.activeCourse = ko.computed(function() {
    var course = this.plannedCourses()[this.activeIndex()];
    if (typeof course === 'undefined') {
      return '';
    }
    return this.plannedCourses()[this.activeIndex()];
  }, this);

  this.isLoading.subscribe(function(isLoading) {
    if (isLoading) {
      this.showFetchAllCourses(false);
    }
  }, this);
  this.getPlannedCourses(API_TAKE, API_SKIP);
}

MyPlannedCourses.prototype.init = function(element) {
  this.$element = $(element);
  // Listen to modal/popup requests.
  ko.postbox.subscribe(
    'openPopup',
    function(value) {
      this.activeModal(!this.activeModal());
      this.modalTitle(value.modalTitle);
      this.modalText(value.modalText);
      this.selectedSequenceId(value.selectedSequenceId);
    }.bind(this)
  );
};

MyPlannedCourses.prototype.setActiveCourse = function(index) {
  this.activeIndex(index);
};

MyPlannedCourses.prototype.closeCancelModal = function() {
  this.isModalActive(false);
};

MyPlannedCourses.prototype.closeModal = function() {
  this.activeModal(false);
};

MyPlannedCourses.prototype.getPlannedCourses = function(take, skip) {
  var self = this,
    url =
      this.API.plannedCoursesUrl +
      '?skip=' +
      encodeURIComponent(skip) +
      '&take=' +
      encodeURIComponent(take);

  this.isLoading(true);
  APIHelper.get(
    url,
    function(response) {
      self.plannedCourses(response.Items);
      self.isLoading(false);

      if (take === API_TAKE_ALL || take >= response.TotalItems) {
        self.showFetchAllCourses(false);
      } else {
        self.showFetchAllCourses(true);
      }
    },
    function() {
      self.isLoading(false);
    }
  );
};

MyPlannedCourses.prototype.getAllCourses = function() {
  this.getPlannedCourses(API_TAKE_ALL, 0);
};

MyPlannedCourses.prototype.confirmCancellation = function() {
  // Only the confirm step may submit, so a double click can't cancel twice.
  if (this.cancellationState() !== 'confirm') {
    return;
  }
  this.cancellationState('pending');

  var self = this,
    url =
      this.API.cancelSequenceRegistrationUrl +
      '?sequencePk=' +
      this.plannedCourses()[this.activeIndex()].Course.SequencePK +
      '&registrationKey=' +
      this.plannedCourses()[this.activeIndex()].RegistrationKey,
    activeIndex = this.activeIndex();

  APIHelper.post(
    url,
    {},
    function() {
      // Only hide the row: activeCourse still has to resolve for the modal to
      // keep rendering the 'done' step, so plannedCourses must stay untouched.
      self.$element
        .find(
          '.my-courses-list .courses-list-item:nth-child(' +
            (activeIndex + 1) +
            ')'
        )
        .slideUp();
      self.cancellationState('done');
    },
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: my-planned-courses.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
      self.cancellationState('error');
    }
  );
};

module.exports = MyPlannedCourses;
